<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="buildingList"
      :items-per-page="10"
      class="elevation-1"
      :options="stateOptions"
      @update:options="onUpdate"
      @click:row="onBuildingClick"
      :search="search"
    >
      <template v-slot:top>
        <v-row
          class="mb-0"
          style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
        >
          <v-col class="d-flex align-center">
            <v-dialog persistent v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small class="ml-4" v-on="on">New Building</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog persistent v-model="unpublishCard" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  class="ml-4"
                  v-on="on"
                  :disabled="!parentMasterplanPublished"
                  >{{ published }} all buildings</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline text-center">{{ published }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <span
                          >This action will {{ published.toLowerCase() }} all
                          buildings.</span
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="unpublishAllBuildings"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <tr>
          {{
            item.name
          }}
        </tr>
      </template>
      <template v-slot:item.action="{ item }">
        <!-- <v-icon small class="mr-3" @click="editPois(item.id)"
          >mdi-alpha-p-circle-outline</v-icon
        > -->
        <v-icon size="18" class="mr-3" @click="editItem(item, $event)"
          >edit</v-icon
        >
        <v-icon size="24" @click="deleteItem(item, $event)">close</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MasterplanService from '../../services/MasterplanService'
export default {
  name: 'BuildingList',
  props: {
    buildingList: {
      type: Array,
      required: true,
      default: function() {
        return {}
      }
    }
  },
  data: function() {
    return {
      headers: [
        { text: 'BUILDING', align: 'left', sortable: true, value: 'name' },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ],
      editedIndex: -1,
      editedItem: {
        id: 0,
        name: '',
        masterplansId: 0
      },
      defaultItem: {
        id: 0,
        name: '',
        masterplansId: 0
      },
      dialog: false,
      unpublishCard: false,
      published: 'Publish',
      mounted: false,
      stateOptions: {},
      search: ''
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Building' : 'Edit Building'
    },
    pageNum() {
      return parseInt(localStorage.buildingListPageState)
    },
    parentMasterplanPublished() {
      if (this.$store.state.MasterplanStore.selectedMasterplan) {
        return this.$store.state.MasterplanStore.selectedMasterplan.publish
      }
    }

    // buildingList() {
    //   return this.$store.state.BuildingStore.buildings;
    // }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created: function() {
    //this.$store.dispatch("BuildingStore/fetchBuildings");
    this.stateOptions = localStorage.buildingListOptions
      ? JSON.parse(localStorage.buildingListOptions)
      : {}
  },
  mounted: function() {
    this.mounted = true
    this.checkIfBuildingsAreAllPublished(this.buildingList)
  },
  methods: {
    onUpdate(value) {
      if (this.mounted) {
        localStorage.buildingListOptions = JSON.stringify(value)
      }
    },
    checkIfBuildingsAreAllPublished(buildingList) {
      buildingList.map(building => {
        if (building.publish) {
          this.published = 'Unpublish'
        }
      })
    },
    unpublishAllBuildings() {
      if (this.parentMasterplanPublished) {
        this.unpublishCard = false
        const buildings = this.buildingList

        this.checkIfBuildingsAreAllPublished(buildings)

        if (this.published === 'Unpublish') {
          this.published = 'Publish'
          buildings.forEach(async building => {
            building.publish = false
            this.$store
              .dispatch('BuildingStore/updateBuilding', building)
              .then(res => {
                this.$store.dispatch('BuildingStore/fetchBuildings')
              })
          })
        } else if (this.published === 'Publish') {
          this.published = 'Unpublish'
          buildings.forEach(async building => {
            building.publish = true
            this.$store
              .dispatch('BuildingStore/updateBuilding', building)
              .then(res => {
                this.$store.dispatch('BuildingStore/fetchBuildings')
              })
          })
        }
      }
    },
    onBuildingClick(building) {
      this.$router
        .push(
          '/masterplans/' +
            this.$route.params.masterplanId +
            '/buildings/' +
            building.id
        )
        .catch(err => {})
    },
    editPois(buildingId) {
      this.$store
        .dispatch('BuildingStore/setSelectedBuilding', buildingId)
        .then(
          this.$store
            .dispatch('PoiStore/setPoiContext', 'building')
            .then(res => {
              this.$router.push('/pois')
            })
        )
    },
    editItem(item, e) {
      // e.stopPropagation()
      // this.editedIndex = this.buildingList.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
    },

    deleteItem(item, e) {
      e.stopPropagation()
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete building',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItemAction(item)
        },
        cancelText: 'Cancel'
      })
    },
    deleteItemAction(item) {
      const index = this.buildingList.indexOf(item)
      this.$store
        .dispatch('BuildingStore/deleteBuilding', item.id)
        .then(res => {
          this.buildingList.splice(index, 1)
        })
    },

    close() {
      this.dialog = false
      this.unpublishCard = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save() {
      if (this.editedIndex > -1) {
        //UPDATE
        //Object.assign(this.buildingList[this.editedIndex], this.editedItem);
        this.$store
          .dispatch('BuildingStore/updateBuilding', this.editedItem)
          .then(res => {
            this.$store.dispatch('BuildingStore/fetchBuildings')
          })
      } else {
        //CREATE
        //this.buildingList.push(this.editedItem);
        this.editedItem.masterplansId = this.$store.state.MasterplanStore.selectedMasterplan.id
        const masterplan = await MasterplanService.getMasterplanById(
          this.editedItem.masterplansId
        )
        if (masterplan.data.publish) {
          this.editedItem.publish = 1
        } else {
          this.editedItem.publish = 0
        }
        this.$store
          .dispatch('BuildingStore/addBuilding', this.editedItem)
          .then(res => {
            this.$store.dispatch('BuildingStore/fetchBuildings')
          })
      }
      this.close()
    }
  }
}
</script>

<style scoped></style>
